import { getId } from 'services/utils'
import {
  findMultipleFacets,
  findSingleFacet,
  bundleFacetIds,
} from 'ui-shared/Facets'
import { parseFacet } from '../facets'
import { parseFoodUpselling } from '../foodUpselling'
import { parseLogistic } from '../logistic'
import { optionedProductParse, optionedProductWrite } from '../optionedProduct'
import { FoodToAPI } from './types/api/request-models'
import { APIFood } from './types/api/response-models'
import { Food } from './types/internal/food-models'

// ============
// PARSE
// ============

const foodParse = (res: APIFood): Food => {
  const logistics = (res.logistics ?? []).map(getId)
  const upsellingItemsFull = res.upselling.map(parseFoodUpselling) // these objects are full of all Food item informations. Used inside event edit and create
  const facets = res.facets.map(parseFacet)
  const logisticsFull = res.logistics.map(parseLogistic)
  const tagFacets = findMultipleFacets(facets, 'tag')
  const filterTypeFacet = findSingleFacet(facets, 'productFilter', 'Type')

  return {
    ...res,
    ...optionedProductParse(res),
    upsellingItemsFull,
    logistics,
    logisticsFull,
    tagFacets,
    filterTypeFacet,
  }
}

// ============
// WRITE
// ============

const foodWrite = async ({
  tagFacets = [],
  filterTypeFacet,
  logistics,
  ...rest
}: Food): Promise<FoodToAPI> => {
  const facets = bundleFacetIds(filterTypeFacet, ...tagFacets)

  return {
    ...(await optionedProductWrite(rest)),
    logistics,
    facets,
  }
}

// ============
// CFG
// ============

const apiCfg = {
  endpoint: 'food',
  parse: foodParse,
  write: foodWrite,
}

export default apiCfg
